import React from "react";
import { FaFacebookF, FaInstagram } from "react-icons/fa";

const SiteFooter = () => {
  return (
    <footer
      className="px-10 py-2.5 flex flex-col md:flex-row justify-between items-center bg-accent-fore
                 text-white w-full outline outline-accent-fore/90 fixed bottom-0 z-10 shadow-[0_-1px_5px_rgba(0,0,0)]"
    >
      <div className="my-2 flex items-center gap-x-5">
        <span className="inline-block">Find us at </span>
        <a
          href="https://www.facebook.com/banglartransit"
          className="hover:underline hover:text-indigo-400"
          title="Facebook"
        >
          <FaFacebookF />
        </a>
        
        <a
          href="https://www.instagram.com/banglartransit"
          className="hover:underline hover:text-fuchsia-500"
          title="Instagram"
        >
          <FaInstagram size={20} />
        </a>
      </div>

      <div className="my-2 text-center">
        <span>
          Contact us at{" "}
          <a className="hover:underline" href="mailto:bangapopb@gmail.com">
            bangapopb@gmail.com
          </a>
        </span>
      </div>
    </footer>
  );
};

export default SiteFooter;
